import { c as _c } from "react/compiler-runtime";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
export function useManualPageViewTracking() {
  const $ = _c(5);
  const location = useLocation();
  const pageCounterRef = useRef(0);
  const {
    trackEvent
  } = useTrackEvent();
  const lastHrefRef = useRef(null);
  let t0;
  if ($[0] !== trackEvent) {
    t0 = () => {
      pageCounterRef.current = pageCounterRef.current + 1;
      if (window.location.href === lastHrefRef.current) {
        return;
      }
      lastHrefRef.current = window.location.href;
      trackEvent({
        name: "[Amplitude] Page Viewed",
        props: {
          "[Amplitude] Page Domain": window.location.hostname,
          "[Amplitude] Page Path": window.location.pathname,
          "[Amplitude] Page Location": window.location.href,
          "[Amplitude] Page URL": window.location.origin + window.location.pathname,
          "[Amplitude] Page Counter": pageCounterRef.current,
          "[Amplitude] Page Title": "Sphere XG",
          isCustomEvent: true
        }
      });
    };
    $[0] = trackEvent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== location.pathname || $[3] !== trackEvent) {
    t1 = [location.pathname, trackEvent];
    $[2] = location.pathname;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
}